/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Packs_TitleInputs */

const en_directory_ai_tools_packs_title = /** @type {(inputs: Directory_Ai_Tools_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy credits once`)
};

const zh_directory_ai_tools_packs_title = /** @type {(inputs: Directory_Ai_Tools_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性购买积分`)
};

/**
* | output |
* | --- |
* | "Buy credits once" |
*
* @param {Directory_Ai_Tools_Packs_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_packs_title = /** @type {((inputs?: Directory_Ai_Tools_Packs_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Packs_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_packs_title(inputs)
	return zh_directory_ai_tools_packs_title(inputs)
});
export { directory_ai_tools_packs_title as "directory.ai_tools.packs.title" }